export interface TranslationLanguage {
  code: string;
  name: string;
  native: string;
}

// Mirrors backend TranslationLanguages.SupportedCodes (4Comply.Core/Helpers).
// 'en' is the immutable base language — never stored in a tenant's selected list.
export const TRANSLATION_BASE_LANGUAGE: TranslationLanguage = { code: 'en', name: 'English', native: 'English' };

export const TRANSLATION_LANGUAGES: TranslationLanguage[] = [
  { code: 'es', name: 'Spanish', native: 'Español' },
  { code: 'fr', name: 'French', native: 'Français' },
  { code: 'de', name: 'German', native: 'Deutsch' },
  { code: 'pt', name: 'Portuguese', native: 'Português' },
  { code: 'it', name: 'Italian', native: 'Italiano' },
  { code: 'nl', name: 'Dutch', native: 'Nederlands' },
  { code: 'jp', name: 'Japanese', native: '日本語' },
  { code: 'cn', name: 'Chinese (Simplified)', native: '简体中文' },
  { code: 'kr', name: 'Korean', native: '한국어' },
  { code: 'ar', name: 'Arabic', native: 'العربية' }
];

export const RTL_LANGUAGE_CODES: ReadonlyArray<string> = ['ar'];

export function translationLanguageMeta(code: string): TranslationLanguage {
  if (code === TRANSLATION_BASE_LANGUAGE.code) {
    return TRANSLATION_BASE_LANGUAGE;
  }
  return TRANSLATION_LANGUAGES.find((l: TranslationLanguage): boolean => l.code === code)
    ?? { code, name: code, native: '' };
}
